import PropTypes from 'prop-types';
// @mui
import { alpha } from '@mui/material/styles';
import { Link, Stack, Button, Tooltip, IconButton } from '@mui/material';
//
import Iconify from './Iconify';

// ----------------------------------------------------------------------

SocialsButton.propTypes = {
  initialColor: PropTypes.bool,
  links: PropTypes.objectOf(PropTypes.string),
  simple: PropTypes.bool,
  sx: PropTypes.object
};

export default function SocialsButton({ initialColor = false, simple = true, links = {}, sx, ...other }) {
  const SOCIALS = [
    {
      name: 'Linkedin',
      icon: 'eva:linkedin-fill',
      socialColor: '#0A7BBA',
      path: links.linkedin || 'https://www.linkedin.com/company/serviceplug/?viewAsMember=true'
    },
    {
      name: 'Whatsapp',
      icon: 'logos:whatsapp-icon',
      socialColor: '#0A7BBA',
      path: links?.whatsapp || 'https://whatsapp.com/channel/0029Va9ae150VycDEbAJ4d1b'
    }
  ];

  return (
    <Stack sx={{ mx: 5 }} spacing={1} direction="row" flexWrap="wrap" alignItems="center">
      {SOCIALS.map((social) => {
        const { name, icon, path, socialColor } = social;
        return simple ? (
          <Link key={name} href={path} target="_blank">
            <Tooltip title={name} placement="top">
              <IconButton
                color={socialColor}
                sx={{
                  border: `1px solid ${socialColor}`,
                  borderRadius: '7px',
                  color: socialColor,
                  ...(initialColor && {
                    color: socialColor,
                    '&:hover': {
                      bgcolor: alpha(socialColor, 0.08)
                    }
                  }),
                  ...sx
                }}
                {...other}
              >
                <Iconify icon={icon} sx={{ width: 20, height: 20 }} />
              </IconButton>
            </Tooltip>
          </Link>
        ) : (
          <Button
            key={name}
            href={path}
            color="inherit"
            variant="outlined"
            size="small"
            startIcon={<Iconify icon={icon} />}
            sx={{
              m: 0.5,
              flexShrink: 0,
              ...(initialColor && {
                color: socialColor,
                borderColor: socialColor,
                '&:hover': {
                  borderColor: socialColor,
                  bgcolor: alpha(socialColor, 0.08)
                }
              }),
              ...sx
            }}
            {...other}
          >
            {name}
          </Button>
        );
      })}
    </Stack>
  );
}
